var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "#99ADBA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73442 6.83047L0.110139 2.21049C-0.0367132 2.06257 -0.0367132 1.82339 0.110139 1.67547L0.728792 1.05234C0.875644 0.904428 1.11311 0.904428 1.25996 1.05234L5 4.78169L8.74004 1.05234C8.88689 0.904429 9.12436 0.904429 9.27121 1.05234L9.88986 1.67548C10.0367 1.82339 10.0367 2.06257 9.88986 2.21049L5.26558 6.83047C5.11873 6.97839 4.88127 6.97839 4.73442 6.83047Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.eb8bb023.svg";
export { ForwardRef as ReactComponent };